<template>
  <path
    d="M12.09 2.91018C10.08 0.900183 7.07 0.490183 4.65 1.67018L8.28 5.30018C8.67 5.69018 8.67 6.32018 8.28 6.71018L6.69 8.30018C6.3 8.70018 5.67 8.70018 5.28 8.30018L1.65 4.67018C0.480003 7.10018 0.890003 10.0902 2.9 12.1002C4.76 13.9602 7.48 14.4502 9.79 13.5802L17.75 21.5402C18.78 22.5702 20.44 22.5702 21.46 21.5402C22.49 20.5102 22.49 18.8502 21.46 17.8302L13.54 9.90018C14.46 7.56018 13.98 4.80018 12.09 2.91018Z"
  />
</template>
